<template>
  <template v-if="!modStatus">
    <commonTable
      :fields="runcardTableFields"
      :items="runcardItem.slice(0, -1)"
      :otherTheme="'thead-green'"
      stickyHeader="447px"
    >
      <template #cell(index)="data">{{ data.index + 1 }}</template>
      <template #cell(screw_weight)="data">{{
        data.value.toLocaleString("en-US")
      }}</template>
      <template #cell(bucket_weight)="data">{{
        data.value.toLocaleString("en-US")
      }}</template>
    </commonTable>
  </template>
  <template v-else>
    <commonTable
      :fields="runcardTableFields"
      :items="runcardItem"
      :otherTheme="'thead-green'"
      stickyHeader="447px"
      class="modRuncardTable"
    >
      <template #cell(index)="data">
        <template v-if="data.index + 1 != runcardItem.length">
          {{ data.index + 1 }}
        </template>
      </template>
      <template #cell(runcard_code)="data">
        <template v-if="data.index + 1 != runcardItem.length">
          <input
            type="text"
            @blur="checkChangeInput('runcard_code', data.index)"
            v-model="runcardItem[data.index].runcard_code"
            style="width: 157px; height: 100%"
            class="text-center"
          />
        </template>
      </template>
      <template #cell(furnace_code)="data">
        <template v-if="data.index + 1 != runcardItem.length">
          <input
            type="text"
            @blur="checkChangeInput('furnace_code', data.index)"
            v-model="runcardItem[data.index].furnace_code"
            style="width: 157px; height: 100%"
            class="text-center"
          />
        </template>
      </template>
      <template #cell(screw_weight)="data">
        <template v-if="data.index + 1 != runcardItem.length">
          <input
            type="text"
            @blur="checkChangeInput('screw_weight', data.index)"
            v-model="runcardItem[data.index].screw_weight"
            style="width: 157px; height: 100%"
            class="text-center"
          />
        </template>
      </template>
      <template #cell(bucket_weight)="data">
        <template v-if="data.index + 1 != runcardItem.length">
          <input
            type="text"
            @blur="checkChangeInput('bucket_weight', data.index)"
            v-model="runcardItem[data.index].bucket_weight"
            style="width: 157px; height: 100%"
            class="text-center"
          />
        </template>
      </template>
      <template #cell(del)="data">
        <template v-if="data.index + 1 != runcardItem.length">
          <button
            class="btn orderManagement-table-button px-2 py-0"
            @click="onRuncardDeleteClicked(data.index)"
          >
            刪除
          </button>
        </template>
        <template v-else>
          <button
            class="btn orderManagement-table-button px-2 py-0"
            @click="onRuncardAddClicked"
          >
            新增
          </button>
        </template>
      </template>
    </commonTable>
  </template>
</template>

<script>
import commonTable from "@/components/commonTable.vue";
import { ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  name: "runcardTable",
  components: {
    commonTable,
  },
  props: {
    workID: {
      type: String,
      default: [],
    },
    runcardItem: {
      type: Array,
      default: [],
    },
    reason: {
      type: Array,
      default: [],
    },
    modStatus: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();

    //dispatch
    const methods = {
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    //查詢結果表格
    const runcardTableFields = ref([]);

    const setField = () => {
      if (props.modStatus == false) {
        runcardTableFields.value = [
          {
            key: "index",
            label: "項次",
            thStyle: {
              "min-width": "55px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "runcard_code",
            label: "流程卡號",
            thStyle: {
              "min-width": "175px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "furnace_code",
            label: "爐號",
            thStyle: {
              "min-width": "230px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "screw_weight",
            label: "重量(KG)",
            thStyle: {
              "min-width": "485px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "bucket_weight",
            label: "桶重(KG)",
            thStyle: {
              "min-width": "180px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
        ];
      } else if (props.modStatus == true) {
        runcardTableFields.value = [
          {
            key: "index",
            label: "項次",
            thStyle: {
              "min-width": "55px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "runcard_code",
            label: "流程卡號",
            thStyle: {
              "min-width": "175px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "furnace_code",
            label: "爐號",
            thStyle: {
              "min-width": "230px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "screw_weight",
            label: "重量(KG)",
            thStyle: {
              "min-width": "485px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "bucket_weight",
            label: "桶重(KG)",
            thStyle: {
              "min-width": "180px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "del",
            label: "刪除",
            thStyle: {
              "min-width": "90px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
        ];
      }
    };

    const checkChangeInput = (position, index = null) => {
      switch (position) {
        case "runcard_code":
          console.log("runcard_code");
          let runcard_code = props.runcardItem[index].runcard_code;
          if (runcard_code == "" || runcard_code == undefined) {
            props.runcardItem[index].runcard_code =
              props.runcardItem[index].orgRuncard_code;
            methods.setTimeoutAlert(`流程卡號不可為空，請再次確認`);
            return;
          }

          let re = new RegExp(props.workID + "-[0-9]{2}");console.log('re',re,'props.workID',props.workID);
          if (re.test(runcard_code) == false) {
            props.runcardItem[index].runcard_code =
              props.runcardItem[index].orgRuncard_code;
            methods.setTimeoutAlert(`流程卡號格式錯誤，請再次確認`);
            return;
          }

          for (let i = 0; i < props.runcardItem.length - 1; i++) {
            if (i == index) {
              continue;
            }
            if (props.runcardItem[i]["runcard_code"] == runcard_code) {
              props.runcardItem[index].runcard_code =
                props.runcardItem[index].orgRuncard_code;
              methods.setTimeoutAlert(`流程卡號已存在，請再次確認`);
              return;
            }
          }

          props.runcardItem[index].orgRuncard_code = runcard_code;

          var queryIndex =
            props.runcardItem[index].reason.indexOf("runcard_code");
          if (props.runcardItem[index].in_runcard_code != runcard_code) {
            if (queryIndex == -1) {
              props.runcardItem[index].reason.push("runcard_code");
            }
          } else {
            //舊的跟新的一樣
            if (queryIndex != -1) {
              props.runcardItem[index].reason.splice(queryIndex, 1);
            }
          }
          break;
        case "furnace_code":
          console.log("furnace_code");
          let furnace_code = props.runcardItem[index].furnace_code;
          if (furnace_code == "" || furnace_code == undefined) {
            props.runcardItem[index].furnace_code =
              props.runcardItem[index].orgFurnace_code;
            methods.setTimeoutAlert(`爐號不可為空，請再次確認`);
            return;
          }

          props.runcardItem[index].orgFurnace_code = furnace_code;

          var queryIndex =
            props.runcardItem[index].reason.indexOf("furnace_code");
          if (props.runcardItem[index].in_furnace_code != furnace_code) {
            if (queryIndex == -1) {
              props.runcardItem[index].reason.push("furnace_code");
            }
          } else {
            //舊的跟新的一樣
            if (queryIndex != -1) {
              props.runcardItem[index].reason.splice(queryIndex, 1);
            }
          }
          break;
        case "screw_weight":
          console.log("screw_weight");
          let screw_weight = props.runcardItem[index].screw_weight;
          if (screw_weight < 0 || screw_weight == "" || isNaN(screw_weight)) {
            props.runcardItem[index].screw_weight =
              props.runcardItem[index].orgScrew_weight;
            methods.setTimeoutAlert(`重量僅能是正數，請再次確認`);
            return;
          }
          props.runcardItem[index].orgScrew_weight = screw_weight;

          var queryIndex =
            props.runcardItem[index].reason.indexOf("screw_weight");
          if (props.runcardItem[index].in_screw_weight != screw_weight) {
            if (queryIndex == -1) {
              props.runcardItem[index].reason.push("screw_weight");
            }
          } else {
            //舊的跟新的一樣
            if (queryIndex != -1) {
              props.runcardItem[index].reason.splice(queryIndex, 1);
            }
          }
          break;
        case "bucket_weight":
          console.log("bucket_weight");
          let bucket_weight = props.runcardItem[index].bucket_weight;
          if (
            bucket_weight < 0 ||
            bucket_weight == "" ||
            isNaN(bucket_weight)
          ) {
            props.runcardItem[index].bucket_weight =
              props.runcardItem[index].orgBucket_weight;
            methods.setTimeoutAlert(`桶重僅能是正數，請再次確認`);
            return;
          }
          props.runcardItem[index].orgBucket_weight = bucket_weight;

          var queryIndex =
            props.runcardItem[index].reason.indexOf("bucket_weight");
          if (props.runcardItem[index].in_bucket_weight != bucket_weight) {
            if (queryIndex == -1) {
              props.runcardItem[index].reason.push("bucket_weight");
            }
          } else {
            //舊的跟新的一樣
            if (queryIndex != -1) {
              props.runcardItem[index].reason.splice(queryIndex, 1);
            }
          }
          break;

        default:
          break;
      }
    };
    const onRuncardDeleteClicked = (index) => {
      props.runcardItem.splice(index, 1);
    };
    const onRuncardAddClicked = () => {
      props.runcardItem.push({
        index: "",
        in_runcard_code: "",
        runcard_code: "",
        orgRuncard_code: "",
        in_furnace_code: "",
        furnace_code: "",
        orgFurnace_code: "",
        in_screw_weight: "",
        screw_weight: "",
        orgScrew_weight: "",
        in_bucket_weight: "",
        bucket_weight: "",
        orgBucket_weight: "",
        reason: [],
        del: "",
      });
    };
    watch(
      () => props.modStatus,
      () => {
        setField();
      },
      { deep: true }
    );

    setField();

    return {
      runcardTableFields,
      checkChangeInput,
      onRuncardDeleteClicked,
      onRuncardAddClicked,
    };
  },
};
</script>

<style>
.modRuncardTable table tbody tr:last-child td {
  border: none;
}
</style>
